// extracted by mini-css-extract-plugin
export default {"title":"Welcome_title__pkIFl","text":"Welcome_text__qailv"};